import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastProvider } from "./components/base/Toast";
import { AuthProvider } from "./contexts/AuthContext";
import ApiErrorNotifier from "./components/feature/ApiErrorNotifier";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <ApiErrorNotifier />
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;